<template>
  <div class="input-modal-wrapper" @click.self="dropdown = false">
    <div class="input-modal" @click.self="dropdown = false">
      <span class="tms close" @click.prevent="close()">F</span>
      <form>
        <template v-if="type === 'activity'">
          <h2 v-if="!this.obj">НОВО СМР</h2>
          <h2 v-else>РЕДАКТИРАЙ СМР</h2>
          <label for="inputActivityField" class="input-label">Име на СМР</label>
        </template>
        <template v-else-if="type === 'material'">
          <h2 v-if="!this.obj">НОВ МАТЕРИАЛ</h2>
          <h2 v-else>РЕДАКТИРАЙ МАТЕРИАЛ</h2>
          <label for="inputActivityField" class="input-label"
            >Име на материала</label
          >
        </template>
        <template v-else-if="type === 'mechanization'">
          <h2 v-if="!this.obj">НОВА МЕХАНИЗАЦИЯ</h2>
          <h2 v-else>РЕДАКТИРАЙ МЕХАНИЗАЦИЯ</h2>
          <label for="inputActivityField" class="input-label"
            >Име на механизацията</label
          >
        </template>
        <!-- INPUT ACTIVITY -->
        <div class="input-wrapper textarea-wrapper" title="Име">
          <span class="tms">U</span>
          <textarea
            id="inputActivityField"
            type="text"
            placeholder="Име"
            v-model="inputName"
            @keydown.enter.prevent="save()"
          />
        </div>
        <div class="inputs inputs--single" title="Мерна единица" v-if="!nameToEdit">
          <div class="input-wrapper">
            <span class="tms">S</span>
            <input
              id="inputUnitField"
              type="text"
              placeholder="Мерна единица"
              v-model="inputUnit"
              @keydown.enter.prevent="save()"
            />
              <!-- :disabled="type === 'mechanization'" -->
          </div>
        </div>
        <div class="inputs inputs--single" title="Цена" v-if="!nameToEdit">
          <div class="input-wrapper">
            <span class="tms2">a</span>
            <input
              id="inputPriceField"
              type="number"
              placeholder="Цена"
              v-model="inputPrice"
              @keydown.enter.prevent="save()"
            />
          </div>
        </div>
        <div
          class="inputs inputs--single"
          title="Количество"
          v-if="type === 'activity'"
        >
          <div class="input-wrapper">
            <span class="tms2">a</span>
            <input
              id="inputQuantityField"
              type="number"
              placeholder="Количество"
              v-model="inputQuantity"
              @keydown.enter.prevent="save()"
            />
          </div>
        </div>
        <div
          class="inputs inputs--single"
          title="Стойност на заработка"
          v-if="type === 'activity'"
        >
          <div class="input-wrapper">
            <span class="tms2">a</span>
            <input
              id="inputEarningsField"
              type="number"
              placeholder="Стойност на заработка"
              v-model="inputEarnings"
              @keydown.enter.prevent="save()"
            />
          </div>
        </div>
        <div class="input-modal-actions">
          <div>
            <!-- JUST AND EMPTY DIV FOR THE SPACE-BETWEEN RULE TO WORK -->
          </div>
          <div class="btns">
            <button class="btn btn-close" @click.prevent="close()">
              <span class="tms">F</span>
              Отказ
            </button>
            <!-- BUTTON ACCEPT FOR MATERIAL/ACTIVITY-->
            <button
              class="btn btn-new"
              type="submit"
              value="Submit"
              @click.prevent="save()"
            >
              <span class="tms">Y</span>
              Запази
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: ["obj", "parts", "type", "nameToEdit"],
  data() {
    return {
      inputName: "",
      inputUnit: "",
      inputPrice: undefined,
      inputQuantity: undefined,
      inputEarnings: undefined,
      dropdown: false,
      newPart: false,
    };
  },
  methods: {
    save() {
      if (this.isValid()) {
        const item = {
          name: this.inputName,
          unit: this.inputUnit,
          price: this.inputPrice || 0,
        };

        if (this.type === "activity") {
          item.quantity = this.inputQuantity;
          item.earnings = this.inputEarnings;
        }

        if (!this.obj) {
          this.$emit("create", { ...item, isAdditional: true });
        } else {
          this.$emit("edit", item);
        }
        this.close();
      }
    },
    // VALIDATE INPUTS
    isValid() {
      if (!this.inputName) {
        this.$snotify.error("въведете име");
        return false;
      }
      if (!this.inputUnit && !this.nameToEdit) {
        this.$snotify.error("въведете мерна единица");
        return false;
      }
      if (this.type === "activity" && !this.inputQuantity && !this.nameToEdit) {
        this.$snotify.error("въведете количество");
        return false;
      }
      if (this.type === "activity" && !this.inputEarnings && !this.nameToEdit) {
        this.$snotify.error("въведете стойност на заработка");
        return false;
      }
      return true;
    },
    close() {
      this.$emit("close");
    },
    escape(e) {
      if (e.code === "Escape") {
        this.close();
      }
    },
  },
  mounted() {
    if(this.nameToEdit) this.inputName = this.nameToEdit;
    if (this.obj) {
      this.inputName = this.obj.name;
      this.inputUnit = this.obj.unit;
      this.inputPrice = this.obj.price;
      this.inputQuantity = this.obj.quantity;
     if (this.type === "activity") this.inputEarnings = this.obj.earnings;
    } else {
      // if (this.type === "mechanization") {
      //   this.inputUnit = "мсм";
      // }
    }

    window.addEventListener("keydown", this.escape);
  },
  destroyed() {
    window.removeEventListener("keydown", this.escape);
  },
};
</script>

<style scoped>
.input-modal-wrapper {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 21;
}
.input-modal {
  background-color: #fff;
  border-radius: 4px;
  /* border-top: 10px solid #e65100; */
  display: flex;
  flex-direction: column;
  /* height: 60vh; */
  /* overflow: auto; */
  padding: 15px 20px 0;
  position: relative;
  /* width: 600px; */
}
.close {
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  padding: 6px;
  position: absolute;
  right: 14px;
  top: 9px;
  transition: all 0.3s;
}
.close:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
.input-modal-permissions {
  background-color: #f4f4f4;
  border-radius: 4px;
  display: flex;
  justify-content: center;
}
.input-modal-actions {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}
.textarea-wrapper {
  width: 100%;
  margin-bottom: 0;
  max-width: 100%;
}
.textarea-wrapper .tms {
  top: 15px;
}
.textarea-wrapper textarea {
  background-color: #deecf9;
  color: #005a9e;
  font-family: "Google Sans", Helvetica, Arial, sans-serif;
  font-weight: 700;
  min-height: 60px;
  padding-top: 6px;
  resize: vertical;
  width: 100%;
}
.input-wrapper .tms,
.input-wrapper .tms2,
.users-list .tms {
  color: #005a9e;
}
.input-wrapper input {
  color: #005a9e;
  font-weight: 700;
}

.input-wrapper textarea::placeholder,
.input-wrapper input::placeholder {
  font-weight: 400;
}
.input-wrapper input,
.users-list {
  background-color: #deecf9;
}
.invalid .tms {
  color: #d91313;
}
.invalid input {
  background-color: #f8dcdc;
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.inputs {
  display: flex;
  margin-top: 7px;
}
.inputs.inputs--single .input-wrapper {
  width: 100%;
}
.input-wrapper {
  display: flex;
  margin-right: 1em;
  /* margin-bottom: 1em; */
}
.input-wrapper:last-child {
  margin-right: 0px;
  /* margin-bottom: 0px; */
}
form > h2 {
  font-size: 13px;
  font-weight: 700;
  text-align: center;
}

.hide {
  display: none;
}

/* Responsive */
@media screen and (max-width: 1000px) {
  .btn.btn-close {
    margin-bottom: 5px;
  }
}
@media screen and (max-width: 650px) {
  .input-modal {
    width: 90%;
  }
}
@media screen and (max-width: 450px) {
  .inputs {
    flex-direction: column;
  }
  .input-wrapper {
    margin-right: 0px;
  }
  .btns {
    display: flex;
    flex-direction: column;
  }
  .btn.btn-close {
    margin-bottom: 10px;
  }
}
</style>
